import React from 'react';

import {
  styled,
  Typography,
  Link,
  DescriptionList,
  DescriptionItem,
} from '@gogame/components';

import Status from 'scenes/PromoCodes/components/Status';

const StyledTypography = styled(Typography)`
  color: inherit;
  word-break: break-all;
`;

const Metadata = ({ data }) => {
  return (
    <DescriptionList
      variant={'column'}
      data={data}
      stripEmpty={true}
      disableGutters={true}
    >
      <DescriptionItem
        label={'Status'}
        field={'status'}
        type={'status'}
        statusFactory={Status}
      />
      <DescriptionItem
        label={'Requested by'}
        field={'requestedBy'}
        zeroMinWidth={true}
        type={({ value: { name } }) => {
          return data?.jiraLink ? (
            <StyledTypography tooltipText={'Link to Jira Task'} noWrap>
              <Link href={data?.jiraLink} target={'_blank'}>
                {name}
              </Link>
            </StyledTypography>
          ) : (
            <Typography>{name}</Typography>
          );
        }}
      />
      <DescriptionItem
        label={'Last updated by'}
        type={'metadata'}
        value={data}
        userField={'updatedBy.name'}
        dateField={'updatedDate'}
      />
      <DescriptionItem
        label={'Created by'}
        type={'metadata'}
        value={data}
        userField={'createdBy.name'}
        dateField={'createdDate'}
      />
    </DescriptionList>
  );
};

export default Metadata;
